var map = {
	"./Andrea McLeod-Karim.jpg": 1135,
	"./Anjan Sahu.jpg": 1136,
	"./Manohara Raj Karuppasamy.png": 1137,
	"./Michael O’Sullivan UCC.jpg": 1138,
	"./Mrs Nair.png": 1139,
	"./Nicholas Venn Springfield College.jpg": 1140,
	"./Pratik-giri.jpg": 1141,
	"./Praveen raval.57a24d7.jpg": 1142,
	"./Praveen raval.jpg": 1143,
	"./Rylan James.jpg": 1144,
	"./Shahina Khaitri.jpg": 1145,
	"./anjan.jpg": 1146,
	"./asif.png": 1147,
	"./avtar-1.png": 1148,
	"./fair-1.png": 1149,
	"./fair-2.png": 1150,
	"./fair-3.png": 1151,
	"./fair-4.png": 1152,
	"./fair-5.png": 1153,
	"./fair-6.png": 1154,
	"./img-1.png": 1155,
	"./mahonaraj.png": 1156,
	"./mehoonri.jpg": 1157,
	"./prathamesh.jpg": 1158,
	"./rylan.jpg": 1159,
	"./sandeep.jpg": 1160,
	"./seeneen mulla.jpg": 1161,
	"./shahnia.jpg": 1162,
	"./siddhi.jpg": 1163,
	"./sinjo.jpg": 1164,
	"./sonia.jpg": 1165
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 338;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial ^\.\/.*$
// module id = 338
// module chunks = 1